import { useEffect, useRef } from 'react'
import { trackFb } from './fbPixel'

export function useTrackSection(sectionId: string, contentName: string) {
  const tracked = useRef(false)

  useEffect(() => {
    if (tracked.current) return
    const el = document.getElementById(sectionId)
    if (!el) return

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !tracked.current) {
          tracked.current = true
          trackFb('ViewContent', {
            content_name: contentName,
            content_category: 'Kinesiología Resuelta',
          })
          observer.disconnect()
        }
      },
      { threshold: 0.3 },
    )
    observer.observe(el)
    return () => observer.disconnect()
  }, [sectionId, contentName])
}
